import { render } from "./Reviews_Section.vue?vue&type=template&id=521cc6ea&scoped=true"
import script from "./Reviews_Section.vue?vue&type=script&lang=js"
export * from "./Reviews_Section.vue?vue&type=script&lang=js"

import "./Reviews_Section.vue?vue&type=style&index=0&id=521cc6ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521cc6ea"]])

export default __exports__